<template>
    <v-app id="app">
        <!-- App bar -->
        <v-app-bar app clipped-right color="bal-gray" light flat>
            <v-app-bar-nav-icon large @click.stop="toggleDrawer" />
            <v-toolbar-title
                >{{ `${$route.meta.title}` | t
                }}<span style="color:gray;">{{ ` (${shopsCount})` }}</span></v-toolbar-title
            >
            <v-combobox
                :items="searchHistory"
                :value="searchShopString"
                @input="controlSearchString($event)"
                item-text="keyword"
                id="searchInput"
                class="mt-6 mx-2"
                :placeholder="'Shop name, company, type, city, product name, product code' | t"
                prepend-inner-icon="search"
                flat
                solo
                dense
                clearable
                v-if="hasPermissionForAction(PermissionsConstants.SHOP, PermissionsConstants.SEARCH)"
            >
                <template slot="item" slot-scope="data">
                    <span @click="updateShopSearch(data.item.keyword)" style="width: 100%; height: 100%" class="pa-2">{{
                        data.item.keyword
                    }}</span>
                </template>
            </v-combobox>
        </v-app-bar>

        <!-- Drawer left -->
        <main-drawer :drawer-open="mainDrawerOpen" @close="toggleDrawer" />

        <!-- Main content -->
        <v-main>
            <shops-map-view />
        </v-main>

        <!-- Footer -->
        <page-footer />
    </v-app>
</template>
<script>
import MainDrawer from "../components/main-drawer.vue";
import PageFooter from "../components/page-footer.vue";

import { mapGetters, mapState, mapActions } from "vuex";
import Store from "../store";
import ShopsMapView from "../pages/shops-map/shops-map-view";
import { PermissionsConstants } from "@/permissions";
export default {
    name: "shops-map-layout",
    components: {
        ShopsMapView,
        PageFooter,
        MainDrawer
    },
    data() {
        return {
            mainDrawerOpen: null,
            searchString: ""
        };
    },
    async created() {
        await Store.dispatch("SearchHistoryStore/getSearchHistory", this.$route.path.replace("/", ""));
    },
    mounted() {
        document.addEventListener("keydown", this.handleKeyboardListener);
        const drawerState = localStorage.getItem("mainDrawerOpen");
        if (drawerState) {
            this.mainDrawerOpen = JSON.parse(drawerState);
        } else {
            this.mainDrawerOpen = true;
        }
    },
    destroyed() {
        if (this.searchShopString.length > 0) Store.commit("ShopsMapStore/resetShopSearch");
        Store.commit("ShopsMapStore/setRequestSuccess", false);
        document.removeEventListener("keydown", this.handleKeyboardListener);
    },
    methods: {
        toggleDrawer() {
            this.mainDrawerOpen = !this.mainDrawerOpen;
            localStorage.setItem("mainDrawerOpen", this.mainDrawerOpen);
        },
        updateShopSearch(value) {
            Store.commit("ShopsMapStore/updateShopSearch", { term: value });
            if (this.map.getZoom() > 7) {
                this.map.setZoom(7);
                this.map.setCenter({ lat: 58.865278, lng: 25.560598 });
            }
        },
        handleKeyboardListener(e) {
            if (e.keyCode === 13 && document.activeElement.tagName === "INPUT") {
                Store.commit("ShopsMapStore/updateShopSearch", {
                    term: document.querySelector("#searchInput").value
                });
            }
        },
        controlSearchString(value) {
            if (value == "") {
                Store.dispatch("SearchHistoryStore/getSearchHistory", this.$route.path.replace("/", ""));
                this.updateShopSearch(value);
            }
        },
        ...mapActions("SearchHistoryStore", ["getSearchHistory"])
    },
    computed: {
        ...mapState("ShopsMapStore", ["drawerOpen", "searchShopString", "map", "showLoader"]),
        ...mapGetters("ShopsMapStore", ["shopsCount"]),
        ...mapState("SearchHistoryStore", ["searchHistory"]),
        ...mapGetters(["hasPermissionForAction"]),
        PermissionsConstants() {
            return PermissionsConstants;
        }
    }
};
</script>

<style scoped></style>
